<template>
  <v-app light>
    <v-container fluid>

      <v-toolbar dense
                 app
                 fixed>
        <v-btn router
               flat
               to="/viewfreight"
               class="teal--text darken-2">Kangaruu</v-btn>
        <v-spacer></v-spacer>

        <v-btn class="teal--text darken-2"
               router
               flat
               to="/news">
          News
        </v-btn>

        <v-btn class="teal--text darken-2"
               router
               flat
               to="/login">
          login
        </v-btn>

      </v-toolbar>

      <main>
        <v-content>
          <router-view></router-view>
        </v-content>
      </main>

      <v-footer class="teal--text darken-2"
                :fixed="fixed"
                app>
        <span class="copyright">&copy; 2018 Kangaruu</span>
        <v-spacer></v-spacer>
      </v-footer>
    </v-container>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {},
  data () {
    return {
      fixed: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue